import { networkRequestStatusReducer } from 'actions/network/reducer'
import { demographicsReducer } from 'components/demographics'
import { filter } from 'components/filter'
import { answersReducer } from 'components/question'
import { connectRouter } from 'connected-react-router'
import { combineReducers } from 'redux'
import { readerAnswersReducer } from 'sagas/downloadFromFirebase/reducer'
import { reducer as isProcessing } from 'actions/processing/reducer'
import { calculationResults } from 'actions/calculationResults/reducer'

import { StateType } from 'typesafe-actions'

// @ts-ignore
const createRootReducer = history =>
  combineReducers({
    answers: answersReducer,
    demographics: demographicsReducer,
    downloadStatus: networkRequestStatusReducer('download'),
    filter,
    readerAnswers: readerAnswersReducer,
    router: connectRouter(history),
    uploadStatus: networkRequestStatusReducer('upload'),
    isProcessing,
    calculationResults
  })

export type RootState = StateType<ReturnType<typeof createRootReducer>>
export default createRootReducer
